import { Alert, Flex, Modal,  Space, Switch, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { IAB_CHOICES_SYSTEM_IDS, StateCodeRender } from "../../../helper";
import { region_title_index_map } from "../../../../../../constants";
import SelectWithSelectAll from "../../../../../../styleguide/components/SelectWithSelectAll";

const { Text } = Typography;

const RespectGpcModal = (props) => {
  const [respectGPC, setRespectGPC] = useState(props.respectGpcCategory.respectGPC);

  const availableGpcStates =  props.regionsInVendorList?.map((usPrefix) => usPrefix.replace("US_", "STATE_")); // GPC_ENABLED_STATES is STATE_ prefixed as we have been saving category[].respecGPC with STATE_ prefix for national (usnat) solution. 

  useEffect(() => {
    props.setCategories((categories) => categories.map(cat => {
      if(cat.purposeRef?.systemId === IAB_CHOICES_SYSTEM_IDS.saleAndSharing) {
        const filteredGpcData = cat.respectGPC?.filter((regionCode) => availableGpcStates.includes(regionCode)) ?? null;
        cat.respectGPC = filteredGpcData?.length ? filteredGpcData : null; 
      }
      return cat;
    }));
    setRespectGPC((currentRespectGPC) =>{
      const filteredGpcData = currentRespectGPC?.filter((regionCode) => availableGpcStates.includes(regionCode)) ?? null;
      return filteredGpcData?.length ? filteredGpcData : null; 
    });
  }, []);

  function handleSwitchChange(checked) {
    if(checked){
      setRespectGPC(availableGpcStates)
    } else {
      setRespectGPC(null)
    }
  }

  function handleSaveChange() {
    props.setCategories((categories) => categories.map(cat => {
      if(cat.purposeRef?.systemId === IAB_CHOICES_SYSTEM_IDS.saleAndSharing) {
        cat.respectGPC = respectGPC; // This must stay STATE_ prefixed
      }
      return cat;
    }));
    props.closeModal();
  }

  const gpcDropdownOption = availableGpcStates
    .map((code) => ({
      label: region_title_index_map[code],
      value: code,
      icon: props.isNoFrameworkFlow || props.isGlobalStandardFlow ? null : <StateCodeRender stateCode={code}/>
    }));

  const isRespectGpcEmpty = Boolean(respectGPC) && !Boolean(respectGPC.length);

  return (
    <Modal
      open={props.openModal}
      title="Global Privacy Control"
      okText="Save"
      onOk={handleSaveChange}
      cancelButtonProps={{
        type: "link"
      }}
      okButtonProps={{
        disabled: isRespectGpcEmpty || props.readOnly,
        title: isRespectGpcEmpty ? "Please select at least one region" : null
      }}
      onCancel={props.closeModal}
      width={"50vw"}
    >
      <Flex vertical gap={32}>
        <Space><Switch disabled={props.readOnly || (gpcDropdownOption?.length === 0)} checked={Boolean(respectGPC)} onChange={handleSwitchChange}/><Text>Respect <a href="https://docs.sourcepoint.com/hc/en-us/articles/8357018608019-Global-Privacy-Control-GPC-" target="_blank"><u>Global Privacy Control</u></a></Text></Space>
        <Space direction="vertical" size={4}>
          <Text>Select regions GPC should apply to</Text>
          <SelectWithSelectAll
            options={gpcDropdownOption ?? []}
            value={respectGPC ?? []}
            onChange={setRespectGPC}
            width={320}
            disabled={!Boolean(respectGPC)}
          />
        </Space>
        <Alert type="info" showIcon closable message={<>Note: Enabling this setting only applies to opting out of the <Typography.Text code>{props.respectGpcCategory?.privacyChoice}</Typography.Text>  privacy choice. A state will only be displayed if the legal basis for that privacy choice is set to something other than Not Applicable.</>}/>
      </Flex>
    </Modal>
  )
}

export default RespectGpcModal;
